import { sendAPIRequest } from "shared/utils/requests";

export const UPDATE_SEGMENT = "UPDATE_SEGMENT";
export const INSERT_SEGMENT = "INSERT_SEGMENT";
export const DELETE_SEGMENT = "DELETE_SEGMENT";

export const updateSegment = (index, segment) => (
    {
        type: UPDATE_SEGMENT,
        index,
        segment,
    }
);

export const insertSegment = (index, segment) => (
    {
        type: INSERT_SEGMENT,
        index,
        segment,
    }
);

export const deleteSegment = (index) => (
    {
        type: DELETE_SEGMENT,
        index,
    }
)